import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/reducers';
import useResponsive from '../../hooks/useResponsive';
import { setChatModal, setNotificationModal, setWalletModal } from '../../store/reducers/ModalsState/slice';
import NavbarBox from './NavbarBox/NavbarBox';
import HeaderMobile from './HeaderMobile/HeaderMobile';
import { Routes } from '../../constants/routes';
import Button from '../Button/Button';
import IconBox from '../../../../website/components/shared/IconBox/IconBox';
import styles from './Header.module.scss';
import { profileIcons } from './HeaderIcon';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import { ReactComponent as DarkModeIcon } from '../../assets/icons/dark-mode-icon.svg';
import { ReactComponent as LightModeIcon } from '../../assets/icons/light-mode.svg';
import MyAccountSubHeader from './SubHeader/MyAccountSubHeader/MyAccountSubHeader';
import { BlockScreenWrapperContext } from '../../providers/AppBlockScreenProvider';
import NumberCircle from '../NumberCircle/NumberCircle';
import { getChatList } from '../../store/reducers/Chat/slice';
import { setDarkMode } from '../../store/reducers/Settings/slice';
import { getNotifications } from '../../store/reducers/Notifications/slice';
import SharedHeader from '../../../../website/components/shared/Header/Header';
import StablesSubHeader from './SubHeader/StablesSubHeader/StablesSubHeader';
import { persistDarkMode } from '../../helpers/darkMode';
const subHeaderArray = [
    {
        component: _jsx(MyAccountSubHeader, {}),
        routes: [Routes.MY_ACCOUNT, Routes.NOTIFICATIONS]
    },
    {
        component: _jsx(StablesSubHeader, {}),
        routes: [Routes.STABLES, Routes.BREEDING, Routes.STABLES_LIST]
    }
    // {
    //     component: <RaceSubHeader />,
    //     routes: [
    //         Routes.RACE,
    //         Routes.UPCOMING_EVENTS,
    //         Routes.RESULTS,
    //         Routes.WINNINGS,
    //         Routes.LEADERBOARDS
    //     ]
    // },
    // {
    //     component: <MarketplaceSubHeader />,
    //     routes: [Routes.MARKETPLACE, Routes.SELL, Routes.ACTIVITY]
    // }
];
const Header = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const isResponsive = useResponsive('xl');
    const { loggedIn } = useAppSelector((state) => state.auth);
    const { chats, needGetChatList } = useAppSelector((state) => state.chat);
    const { userNotifications, needGetNotificationList, metaData: { page }, limit } = useAppSelector((state) => state.notifications);
    const [hamburgerMenu, setHamburgerMenu] = useState(false);
    const { walletModal } = useAppSelector((state) => state.modal);
    const { balance, isConnected, address } = useAppSelector((state) => state.wallet.activeWallet);
    const { darkMode } = useAppSelector((state) => state.settings);
    const blockScreen = useContext(BlockScreenWrapperContext);
    useEffect(() => {
        if (loggedIn && isConnected && chats.length === 0 && needGetChatList) {
            dispatch(getChatList());
        }
    }, [dispatch, isConnected, loggedIn, chats, needGetChatList]);
    useEffect(() => {
        if (loggedIn && isConnected && userNotifications.length === 0 && needGetNotificationList) {
            dispatch(getNotifications({ page, limit }));
        }
    }, [dispatch, isConnected, loggedIn, userNotifications, needGetNotificationList, page, limit]);
    const unread = useMemo(() => {
        return chats.reduce((unread, chat) => unread + chat.state.unread || 0, 0);
    }, [chats, address]);
    const unreadNotificationCount = useMemo(() => {
        return userNotifications.filter((notification) => !notification.isRead).length;
    }, [userNotifications, address]);
    const toggleTabs = {
        user: () => {
            navigate(Routes.MY_ACCOUNT);
        },
        messages: () => {
            dispatch(setChatModal(true));
        },
        bell: () => {
            !isResponsive ? dispatch(setNotificationModal(true)) : navigate(Routes.NOTIFICATIONS);
        }
    };
    const darkThemeHandler = () => {
        dispatch(setDarkMode(!darkMode));
        persistDarkMode(!darkMode);
    };
    const DarkModeComponent = (_jsx(IconBox, Object.assign({ className: styles.mode, type: 2 }, { children: !darkMode ? (_jsx(DarkModeIcon, { onClick: darkThemeHandler })) : (_jsx(LightModeIcon, { onClick: darkThemeHandler })) })));
    const renderSubHeader = (pathname) => subHeaderArray.reduce((acc, { component, routes }) => (routes.includes(pathname) ? component : acc), _jsx(_Fragment, {}));
    //Connected Profile Icons
    const ProfileIcons = profileIcons.map(({ icon, name, parent }, index) => (_jsxs(IconBox, Object.assign({ onClick: () => {
            toggleTabs[name]();
        }, className: cn(styles.profile, parent && pathname.startsWith(parent) && styles.active) }, { children: [icon, name === 'bell' && !!unreadNotificationCount && (_jsx("div", Object.assign({ className: styles.numberCircle }, { children: _jsx(NumberCircle, { reverse: true, size: 'small', text: unreadNotificationCount }) }))), name === 'messages' && !!unread && (_jsx("div", Object.assign({ className: styles.numberCircle }, { children: _jsx(NumberCircle, { reverse: true, size: 'small', text: unread }) })))] }), index)));
    const handleChange = () => {
        dispatch(setDarkMode(!darkMode));
        // setLocalDarkMode(!darkMode);
    };
    //Connect Button
    const ConnectButton = (_jsx(Button, { to: Routes.LOGIN, type: 'NavLink', size: 'sm', className: cn(styles.create, isResponsive && styles.createMobile), text: t('connect_wallet') }));
    const LogoComponent = (_jsx("a", Object.assign({ href: process.env.REACT_APP_EQUINE_URL }, { children: _jsx(Logo, { className: styles.logo }) })));
    return (_jsx(_Fragment, { children: _jsx(SharedHeader, { darkMode: darkMode, walletInitializing: false, isResponsive: isResponsive, blockScreen: blockScreen, isApp: true, loggedIn: loggedIn, balance: balance, DarkModeComponent: DarkModeComponent, walletModal: walletModal, hamburgerMenu: hamburgerMenu, ConnectButton: ConnectButton, ProfileIcons: ProfileIcons, NavBarBox: _jsx(NavbarBox, {}), HeaderMobile: _jsx(HeaderMobile, { setMobile: () => setHamburgerMenu((prev) => !prev) }), LogoComponent: LogoComponent, modalToggler: () => dispatch(setWalletModal(true)), SubHeaderComponent: renderSubHeader(pathname), setHamburgerMenu: setHamburgerMenu }) }));
};
export default Header;
